import manageDocuments from './components/manageDocuments.vue';
import extractEntities from './components/extractEntities.vue';
import exploreGraph from './components/exploreGraph.vue';
import manageDocumentUpload from './components/manageDocumentUpload.vue';

export default [
    { name: "home", path: '/', component: manageDocuments },
    { name: "manage_documents", path: '/documents', component: manageDocuments },
    { name: "extract_entities", path: '/entities', component: extractEntities, props: true },
    { name: "explore_graph", path: '/graph', component: exploreGraph },
    { name: "manage_documents_upload", path: '/upload', component: manageDocumentUpload }
]



// WEBPACK FOOTER //
// ./src/routes.js